/**
 * URL страницы акций новостроек
 */
export const NEWBUILDING_PROMO_URL = '/skidki/';
